module.exports = __webpack_public_path__ + "fonts/almoni-regular-aaa.d0eb0f0.woff2";